import { useMessagesQuery } from "@services/messages/queries";

export const useUnreadMessagesCount = (): number => {
  const { data: messages } = useMessagesQuery();
  const unreadMessagesCount = messages?.filter((m) => !m.isRead)?.length;

  return !unreadMessagesCount || unreadMessagesCount === 0
    ? 0
    : unreadMessagesCount;
};
